<template>
    <div class="p-4 text-center">
      <h1 class="text-2xl font-bold">404 - Página no encontrada</h1>
      <p>Lo sentimos, la página que estás buscando no existe.</p>
      <router-link to="/" class="text-indigo-500 hover:text-indigo-700">Volver al inicio</router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NotFound',
  };
  </script>
  
  <style scoped>
  /* Puedes añadir estilos adicionales aquí si es necesario */
  </style>